export const TOTAL_STEPS = 5 as const
export const STEPS = {
    STEP1: 1,
    STEP2: 2,
    STEP3: 3,
    STEP4: 4,
    STEP5: 5,
}

export const SYSTEM_TYPES = {
   GAS_BOILER: 'gas_boiler',
   HEAT_PUMPS: 'heat_pumps',
   SOLAR: 'solar',
   OTHER: 'other',
};
